import { STRUTTURE } from "@/config/site";

export const Strutture = () => (
  <section id="strutture" className="bg-warm py-20 lg:py-28" data-testid="strutture-section">
    <div className="container-ph">
      <div className="reveal max-w-xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">{STRUTTURE.title}</h2>
        <p className="mt-4 text-base sm:text-lg text-ink/70" data-testid="strutture-intro">{STRUTTURE.intro}</p>
      </div>
      <div className="mt-12 grid gap-8 lg:grid-cols-2">
        {STRUTTURE.items.map((s, i) => (
          <article key={s.name} className={`reveal reveal-delay-${i + 1} group bg-white border border-ivory-dark flex flex-col overflow-hidden`} data-testid={`struttura-card-${i + 1}`}>
            <div className="h-64 sm:h-72 overflow-hidden">
              <img src={s.image} alt={s.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
            </div>
            <div className="p-7 sm:p-9 flex flex-col flex-1">
              <h3 className="font-serif text-2xl sm:text-3xl text-forest leading-tight" data-testid={`struttura-card-${i + 1}-name`}>{s.name}</h3>
              <p className="mt-2 eyebrow" data-testid={`struttura-card-${i + 1}-meta`}>{s.tipologia} · {s.localita}</p>
              <p className="mt-4 text-ink/75 leading-relaxed flex-1">{s.text}</p>
              {s.testimonial?.quote && (
                <blockquote className="mt-6 border-l-2 border-bronze/60 pl-4 text-ink/80 italic" data-testid={`struttura-card-${i + 1}-quote`}>
                  “{s.testimonial.quote}”
                  <footer className="mt-2 not-italic text-xs text-ink/55">{s.testimonial.author}{s.testimonial.role ? ` · ${s.testimonial.role}` : ""}</footer>
                </blockquote>
              )}
              <a href={s.url} target="_blank" rel="noopener noreferrer" className="mt-6 self-start text-sm text-ink/55 hover:text-bronze transition-colors" data-testid={`struttura-card-${i + 1}-link`}>{STRUTTURE.linkLabel}</a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
